import html2Canvas from 'html2canvas';

export const htmlToImg = async (domId) => {
  const id = `#${domId}`;
  const imgHeight = document.querySelector(id).offsetHeight; // 获取DOM高度
  const imgWidth = document.querySelector(id).offsetWidth; // 获取DOM宽度
  const scale = 2; // 获取设备像素比
  return new Promise((resolve, reject) => {
    html2Canvas(document.querySelector(id), {
      useCORS: true,
      scale,
      width: imgWidth,
      height: imgHeight,
    }).then((canvas) => {
      // 获取图片 dataURL，也是 base64 格式
      // const base64Url = canvas.toDataURL();
      // resolve(base64Url);
      // 获取图片 blob 对象
      canvas.toBlob((blob) => {
        console.log('blob: ', blob);
        resolve(blob);
      });
    }).catch((err) => {
      reject(err);
    });
  });
};
